




















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import MainTitle from '../_components/MainTitle.vue'
import SubTitle from '../_components/SubTitle.vue'
import Page2Chart1 from '../_components/charts/Page2Chart1.vue'

@Component({
  components: {
    MainTitle,
    SubTitle,
    Page2Chart1
  }
})
export default class extends Vue {
  @Prop({ required: true }) private title!: string
  @Prop({}) private tag!: string
  @Prop({}) private data!: any

  private list: any = []

  created() {
    console.info(this.data)
    this.list = this.data.array
    this.list.map(v => {
      v.chartData = []
      v.chartStandardData = []
      v.barChartVos.map(q => {
        v.chartData.push(q.percentStr)
        v.chartStandardData.push(q.normPercent)
      })
    })
  }
}
